<template>
  <component :is="currentComponent"></component>
</template>

<script>
import store from '@/store/store';

export default {
  data() {
    return {
      loginType: localStorage.getItem('login_type'),
    };
  },
  computed: {
    experience() {
      if (this.loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        const experience = experiences.find((i) => i.id == this.$route.params.id);
        return experience;
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    currentComponent: function () {
      return () =>
        import('@/views/WorkExperiences/' + this.experience.vje.folder_name + '/TourInduction.vue');
    },
  },
};
</script>
